/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetBillingEmailSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type GetBillingEmailRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type GetBillingEmailSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const GetBillingEmailSecurity$outboundSchema: z.ZodMiniType<
  GetBillingEmailSecurity$Outbound,
  GetBillingEmailSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getBillingEmailSecurityToJSON(
  getBillingEmailSecurity: GetBillingEmailSecurity,
): string {
  return JSON.stringify(
    GetBillingEmailSecurity$outboundSchema.parse(getBillingEmailSecurity),
  );
}

/** @internal */
export type GetBillingEmailRequest$Outbound = {
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const GetBillingEmailRequest$outboundSchema: z.ZodMiniType<
  GetBillingEmailRequest$Outbound,
  GetBillingEmailRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
    });
  }),
);

export function getBillingEmailRequestToJSON(
  getBillingEmailRequest: GetBillingEmailRequest,
): string {
  return JSON.stringify(
    GetBillingEmailRequest$outboundSchema.parse(getBillingEmailRequest),
  );
}
